import _extends from "@babel/runtime/helpers/extends";
import { ursaColors } from "@smartsheet/design-tokens";
import React, { forwardRef } from "react";
import { Icon } from "../../icon/Icon";
import SignalBarsIcon20 from "./SignalBarsIcon20";
import SignalBarsIcon24 from "./SignalBarsIcon24";
const getSize = _ref => {
  let {
    value,
    size
  } = _ref;
  if (size === 24) {
    return /*#__PURE__*/React.createElement(SignalBarsIcon24, {
      value: value
    });
  } else return /*#__PURE__*/React.createElement(SignalBarsIcon20, {
    value: value
  });
};
export const SignalBarsIcon = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    color = ursaColors.blue400,
    size,
    style,
    value,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    color: color,
    ref: ref,
    size: size
  }, rest, {
    style: {
      ...style
    }
  }), getSize({
    value,
    size
  }));
});
SignalBarsIcon.displayName = "SignalBarsIcon";
//# sourceMappingURL=SignalBarsIcon.js.map